import ReviewDetailClient from "@/components/admin/ReviewDetailClient";
import { useParams } from "react-router-dom";
import { REVIEWABLE_TYPES } from "@/lib/constants";

export default function ReviewDetailPage() {
    const { type, id } = useParams<{ type: string; id: string }>();

    // Validate review type
    if (!type || !(REVIEWABLE_TYPES as readonly string[]).includes(type)) {
        return (
            <div className="p-8 text-center text-red-600">
                Invalid review type. Must be one of: {REVIEWABLE_TYPES.join(", ")}
            </div>
        );
    }

    return (
        <ReviewDetailClient
            type={type}
            id={id || ""}
            initialItem={null}
        />
    );
}
